import { render, staticRenderFns } from "./compras-cg.vue?vue&type=template&id=b92f1090&scoped=true&"
import script from "./compras-cg.vue?vue&type=script&lang=js&"
export * from "./compras-cg.vue?vue&type=script&lang=js&"
import style0 from "./compras-cg.vue?vue&type=style&index=0&id=b92f1090&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b92f1090",
  null
  
)

export default component.exports